import { DEFAULT_LOCALE, ILOCALES, LOCALES } from "@constants";
import React, { createContext, FC, ReactNode, useState } from "react";
import { useRouter } from "next/router";

type LocalesContextState = {
  locale: "en" | "ja";
  changeLocale: (value: "en" | "ja") => void;
};

export const LocalesContext = createContext<LocalesContextState>(
  {} as LocalesContextState
);

export const LocalesProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const router = useRouter();
  const [locale, setLocale] = useState<ILOCALES>(
    router.asPath.includes("/ja/") ? "ja" : DEFAULT_LOCALE
  );

  const isValidLocale = (locale: string) => {
    return Object.keys(LOCALES).includes(locale);
  };

  const changeLocale = (newLocale: ILOCALES) => {
    if (!isValidLocale(newLocale)) {
      return;
    }

    setLocale(newLocale);
  };

  const value = {
    locale,
    changeLocale,
  };

  return (
    <LocalesContext.Provider value={value}>{children}</LocalesContext.Provider>
  );
};
